import { useHistory, useParams } from "react-router-dom";
import { toast } from "@jsq/ds/core";
import { useUpdatePaymentAccountMutation } from "~/graphql/supergraphHooks";
import { type PaymentAccountInput } from "~/graphql/supergraphTypes";
import { BeneficiaryAccountModal } from "../BeneficiaryAccountModal";
import { usePaymentInstructions } from "../PaymentInstructionsContext";

const EditPaymentBeneficiary = ({ title, sourceUrl }: { title: string; sourceUrl: string }) => {
  const { beneficiaryId } = useParams<{ beneficiaryId: string }>();
  const { caseId } = usePaymentInstructions();
  const history = useHistory();

  const [updatePaymentAccountMutation] = useUpdatePaymentAccountMutation({
    refetchQueries: ["GetInvestorBankDetails", "GetCaseInvestingProfileRiskRating"],
    awaitRefetchQueries: true,
    fetchPolicy: "network-only",
    onError: (e) => {
      toast.error(e.message);
      throw e;
    },
  });

  const handleSubmit = async (requestBody: PaymentAccountInput) => {
    await updatePaymentAccountMutation({
      variables: {
        caseId: caseId,
        paymentAccountId: parseInt(beneficiaryId),
        data: requestBody,
      },
    });
    toast.success("Payment account updated successfully");
    history.push(sourceUrl);
  };
  return (
    <BeneficiaryAccountModal
      title={title}
      handleSubmit={handleSubmit}
      handleNavigateBack={() => history.push(sourceUrl)}
    />
  );
};

export default EditPaymentBeneficiary;
